import * as types from './mutation-types'
// import {
//     adminsRef
// } from '../firebaseApp'

export const signIn = ({
    commit
}, user_payload) => {
    commit(types.SIGN_IN, user_payload)
}

export const signOut = ({
    commit
}) => {
    commit(types.SIGN_OUT)
}

export const loggedIn = ({
    commit
}) => {
    commit(types.LOGGED_IN)
}

export const loggedOut = ({
    commit
}) => {
    commit(types.LOGGED_OUT)
}

export const setAdmin = ({
    commit
}, admin_payload) => {
    commit(types.SET_ADMIN, admin_payload)
}

export const setMember = ({
    commit
}, member_payload) => {
    commit(types.SET_MEMBER, member_payload)
}

export const setAdmins = ({
    commit
}, admins_payload) => {
    commit(types.SET_ADMINS, admins_payload)
}